/**
 * マルチタブセッション競合防止プラグイン
 *
 * 他タブでのログアウトをstorageイベントで検知し、
 * ページリロードによって意図しないデータ混在を防ぐ。
 *
 * storageイベントは同一タブの変更では発火しないため、
 * 自分自身のログアウト操作には影響しない。
 */
import type { Plugin } from '@nuxt/types';

const AUTH_STRATEGY_KEY = 'auth.strategy';
const TOKEN_PREFIX = 'auth._token.';

const isAuthKey = (key: string): boolean =>
  key === AUTH_STRATEGY_KEY || key.startsWith(TOKEN_PREFIX);

const tabSessionGuard: Plugin = (_context) => {
  const handleStorageEvent = (event: StorageEvent): void => {
    // localStorage.clear() 検知: key === null は全削除 = ログアウトとして扱う
    if (event.key === null) {
      window.location.href = '/';
      return;
    }

    if (!isAuthKey(event.key)) { return; }

    const newValue = event.newValue;

    // ログアウト検知: トークンが削除された or 'false' になった
    // NOTE: $auth.loggedIn は @nuxtjs/auth-next がストレージ変更を検知して先に更新するため
    //       ガード条件として使用できない。無条件リロードで対応する。
    if (!newValue || newValue === 'false') {
      window.location.href = '/';
    }
  };

  window.addEventListener('storage', handleStorageEvent);
};

export default tabSessionGuard;
